import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import { trackCustomEvent, OutboundLink } from "gatsby-plugin-google-analytics"
import Img from "gatsby-image"

import { Container } from "./styled"

function ServiceGrid() {
  const {
    algemas,
    balanca,
    delegacia,
    habeas,
    martelinho,
    advogado,
    qrcode,
  } = useStaticQuery(graphql`
    query {
      algemas: file(relativePath: { eq: "algemas.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      balanca: file(relativePath: { eq: "balanca.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2200) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      delegacia: file(relativePath: { eq: "delegacia.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2100) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      habeas: file(relativePath: { eq: "habeas.png" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2095) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      martelinho: file(relativePath: { eq: "martelinho.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2200) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      advogado: file(relativePath: { eq: "advogado.png" }) {
        childImageSharp {
          fluid(maxWidth: 2000, maxHeight: 2000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
      qrcode: file(relativePath: { eq: "qrcode.png" }) {
        childImageSharp {
          fluid(maxWidth: 1000, maxHeight: 1000) {
            ...GatsbyImageSharpFluid_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <Container>
      <div className="grid-container">
        <div className="card-container">
          <div className="card">
              <Img
                className="img"
                fluid={algemas.childImageSharp.fluid}
                alt="Icone de orçamento"
              />
          </div>
          <h3 className="card-label">Execução Penal</h3>
        </div>

        <div className="card-container">
          <div className="card">
              <Img
                className="img"
                fluid={advogado.childImageSharp.fluid}
                alt="Conserto"
              />
          </div>
          <h3 className="card-label">Consultoria Jurídica</h3>
        </div>
        <div className="card-container">
          <div className="card">
              <Img
                className="img"
                fluid={delegacia.childImageSharp.fluid}
                alt="Icone de delegacia"
              />
          </div>
          <h3 className="card-label">Suporte em Flagrante</h3>
        </div>

        <div className="card-container">
          <div className="card">
              <Img
                className="img"
                fluid={habeas.childImageSharp.fluid}
                alt="icone de algemas soltas"
              />
          </div>
          <h3 className="card-label">Habeas Corpus</h3>
        </div>
        <div className="card-container">
            <div className="card">
              <Img
                className="img"
                fluid={martelinho.childImageSharp.fluid}
                alt="Icone do martelinho do juiz"
              />
            </div>
            <h3 className="card-label">Recursos Perante aos Tribunais</h3>
       
        </div>
        <div className="card-container">
          <div className="card">
            <Img
              className="img"
              fluid={balanca.childImageSharp.fluid}
              alt="icone do advogado"
            />

          </div>
          <h3 className="card-label">Defesas em Ações Penais</h3>
        </div>
      </div>

    </Container>
  )
}

export default ServiceGrid
